<script setup lang="ts">
import { photoHeroSchema } from '#imports'

useBlockFormSchema(photoHeroSchema)

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <div class="flex flex-col gap-y-4 pt-4">
    <BaseParagraph class="mt-0">
      {{ t('explanation') }}
    </BaseParagraph>

    <FormImageField
      name="image"
      :label="t('imageLabel')"
      keep-value
      required
    />

    <FormField
      name="slogan"
      :label="t('sloganLabel')"
      required
    />

    <FormField
      name="subtitle"
      :label="t('subtitleLabel')"
    />

    <FormListField
      name="textAlignment"
      :label="t('textAlignmentLabel')"
      :items="['left', 'center', 'right']"
    />

    <FormCheckboxField
      name="breakOut"
      :label="t('breakOutLabel')"
    />

    <FormCheckboxField
      name="maskBottomImage"
      :label="t('maskBottomImage')"
    />

    <FormCheckboxField
      name="showLogoMark"
      :label="t('showLogoMarkLabel')"
    />

    <FormField
      name="height"
      :label="t('heightLabel')"
      type="number"
      :placeholder="t('heightPlaceholder')"
    />

    <FormField
      name="darkOverlayOpacity"
      :label="t('darkOverlayOpacityLabel')"
      type="number"
      :placeholder="t('darkOverlayOpacityPlaceholder')"
    />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "explanation": "Create a full-width hero section with a background image and slogan text.",
    "imageLabel": "Background Image",
    "sloganLabel": "Slogan text (title)",
    "subtitleLabel": "Subtitle text (optional)",
    "showLogoMarkLabel": "Show logo mark",
    "heightLabel": "Height in pixels (optional, default 500px)",
    "heightPlaceholder": "500",
    "darkOverlayOpacityLabel": "Dark overlay opacity (optional, default 30%)",
    "darkOverlayOpacityPlaceholder": "30",
    "breakOutLabel": "Fill the screen width",
    "textAlignmentLabel": "Text alignment",
    "maskBottomImage": "Round the bottom of the image"
  },
  "nl": {
    "explanation": "Maak een hero sectie met een achtergrondafbeelding en slogantekst.",
    "imageLabel": "Achtergrondafbeelding",
    "sloganLabel": "Slogan tekst (titel)",
    "subtitleLabel": "Subtitel tekst (optioneel)",
    "showLogoMarkLabel": "Toon logo beeldmerk",
    "heightLabel": "Hoogte in pixels (optioneel, standaard 500px)",
    "heightPlaceholder": "500",
    "darkOverlayOpacityLabel": "Donkere overlay over afbeelding (standaard 30%)",
    "darkOverlayOpacityPlaceholder": "30",
    "breakOutLabel": "Volledige schermbreedte vullen",
    "textAlignmentLabel": "Tekstuitlijning",
    "maskBottomImage": "Onderkant van afbeelding afronden"
  }
}
</i18n>
